// src/App.js
import React from 'react';
import { useParams } from 'react-router-dom';
// import PostPage from './PostPage';
import PostPage2 from './PostPage2';

const posts = [
    {
        srcc: "https://www.aparat.com/video/video/embed/videohash/d548l3y/vt/frame",
        id: 'a3546dfjkn4321',
        title: 'تصاویر منتشر نشده از حضور حاج قاسم در خوزستان',
        author: '',
        content: (
            <p></p>
        ),
    },


    {
        srcc: "https://cdn.rokna.net/servev2/ucE2q174ALtV/Db2f077dXpA,/+%D8%AD%D8%B6%D9%88%D8%B1+%D8%B3%D8%B1%D8%AF%D8%A7%D8%B1+%D8%B4%D9%87%DB%8C%D8%AF+%D8%AD%D8%A7%D8%AC+%D9%82%D8%A7%D8%B3%D9%85+%D8%B3%D9%84%DB%8C%D9%85%D8%A7%D9%86%DB%8C+%D8%AF%D8%B1+%DA%A9%D9%85%DA%A9+%D8%B1%D8%B3%D8%A7%D9%86%DB%8C+%D8%A8%D9%87+%D9%85%D8%B1%D8%AF%D9%85+%D8%AF%D8%B1+%D8%B3%DB%8C%D9%84+%D8%AE%D9%88%D8%B2%D8%B3%D8%AA%D8%A7%D9%86.mp4",
        id: 'g98bhfj575322',
        title: 'حضور سردار سلیمانی در مناطق سیل زده خوزستان',
        author: '',
        content: "",
    },

    {
        srcc: "https://www.aparat.com/video/video/embed/videohash/x22r96b/vt/frame",
        id: 'd35f2mn4gdf53',
        title: 'تشییع پیکر سردار سلیمانی در اهواز',
        author: '',
        content: "",
    }


]

function PPWrapper() {
    const { id } = useParams();
    const post = posts.find((post) => post.id === (id));

    return post ? (
        <PostPage2
            srcc={post.srcc}
            title={post.title}
            author={post.author}
            content={post.content}
        />
    ) : (
        <p>Post not found</p>
    );
}

export default PPWrapper;
